import { Component, computed, HostListener, inject, input } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-iframe-modal',
  standalone: true,
  imports: [],
  templateUrl: './iframe-modal.html',
  styleUrl: './iframe-modal.scss'
})
export class IframeModal {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly dialogRef = inject(DialogRef);

  url = input.required<string>();

  safeUrl = computed<SafeResourceUrl>(() =>
    this.sanitizer.bypassSecurityTrustResourceUrl(this.url())
  );

  @HostListener('window:message', ['$event'])
  onWindowMessage(event: MessageEvent): void {
    console.log('[IframeModal] message recibido →', {
      origin: event.origin,
      source: event.source === window ? 'self' : (event.source === window.parent ? 'parent' : 'otro'),
      data: event.data
    });

    const data = event?.data;
    if (!data || typeof data !== 'object') return;

    if (data.type === 'closeIframeModal' || data.type === 'iframeModalAction') {
      console.log('[IframeModal] cerrando dialog con result:', data.result ?? data.payload ?? true);
      this.dialogRef.close(data.result ?? data.payload ?? true);
    }
  }
}
